import { AppProvider } from '@shopify/polaris';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';

import { EmbeddedAppProvider } from './components/EmbeddedAppProvider';
import { useSunbowlCapture } from './hooks';
import Dashboard from './pages/Dashboard';
import OrderList from './pages/OrderList';
import OrderDetail from './pages/OrderDetail';
import AddOrder from './pages/AddOrder';
import Settings from './pages/Settings';
import Mockups from './pages/Mockups';
import Digitization from './pages/Digitization';
import Approvals from './pages/Approvals';
import Production from './pages/Production';
import ProductionPrep from './pages/ProductionPrep';
import Shipping from './pages/Shipping';

/**
 * NavMenu component
 *
 * Uses App Bridge's ui-nav-menu web component to add navigation items
 * to the Shopify admin sidebar.
 */
function NavMenu() {
  return (
    <ui-nav-menu>
      <a href="/" rel="home">Dashboard</a>
      <a href="/orders">Custom Orders</a>
      <a href="/mockups">Mockups</a>
      <a href="/digitization">External Services</a>
      <a href="/approvals">Approvals</a>
      <a href="/production">Production</a>
      <a href="/shipping">Shipping</a>
      <a href="/settings">Settings</a>
    </ui-nav-menu>
  );
}

/**
 * App component
 *
 * App Bridge 4.x.x is configured via the script tag in index.html.
 * The window.shopify object is automatically available when embedded in Shopify admin.
 * See: https://shopify.dev/docs/api/app-bridge/migration-guide-react
 */
function App() {
  useSunbowlCapture();

  return (
    <AppProvider i18n={enTranslations}>
      <BrowserRouter>
        <EmbeddedAppProvider>
          <NavMenu />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/orders" element={<OrderList />} />
            <Route path="/orders/add" element={<AddOrder />} />
            <Route path="/orders/:orderId" element={<OrderDetail />} />
            <Route path="/mockups" element={<Mockups />} />
            <Route path="/digitization" element={<Digitization />} />
            <Route path="/approvals" element={<Approvals />} />
            <Route path="/prep" element={<ProductionPrep />} />
            <Route path="/production" element={<Production />} />
            <Route path="/shipping" element={<Shipping />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </EmbeddedAppProvider>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
